import React from "react";
import { Link } from "react-router-dom";
import "./LeafBreadcrumbs.scss";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/leafBreadcrumbs";
import { viewMBIStatementTrack } from "../../tealium/MBI/ILB/ILBStatement";

type Path = {
  label: string;
  url: string;
};

type Props = {
  paths: Path[];
  onClick?: (event: React.MouseEvent<HTMLElement>, url: string) => void;
};

const LeafBreadcrumbs = ({ paths, onClick }: Props) => {
  const { t } = useTranslation(["leafBreadcrumbs"]);

  const handleLinkClick = (url: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(event, url);
    }

    if (url === "/mbi/monthly") {
      viewMBIStatementTrack();
    }
  };

  return (
    <nav
      aria-label={`${t("breadcrumbsAriaLabel", defaultContent["breadcrumbsAriaLabel"])}`}
      role="navigation"
      className="leaf-breadcrumbs"
    >
      <ol>
        {paths.map((path, index) => (
          <li key={index}>
            <Link
              to={path.url}
              aria-current={index === paths.length - 1 ? "page" : undefined}
              onClick={handleLinkClick(path.url)}
            >
              {path.label}
            </Link>
            {index < paths.length - 1 && <span>/</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default LeafBreadcrumbs;
